const scheduledServicesCalendarFilterModal = {
  filter: 'FILTERS',
  clear: 'Clear Filters',
  site: 'Sites',
  user: 'Accountable',
  groups: 'Group',
  place: 'Place',
  area: "Departments",
  company: "Third-Party Company",
  equipmentModel: "Equipment Type",
  frequencies: "Frequencies",
  serviceTypes: "Service Types",
  cancel: "CANCEL",
  ok: "APPLY"
};

export default scheduledServicesCalendarFilterModal;
